import { createContext } from 'react';

const QRContext = createContext();
QRContext.displayName = 'QRContext';

export default QRContext;
